import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Typography from '../typography/Typography';
import { DescriptionWrapper, EmptyStateContainer, Img, ImgWrapper, } from './styles';
const EmptyState = ({ img, title, description, button, className, loading, titleType = 'titleTwo', titleFont = 'primaryBold', }) => {
    const { colors } = useTheme();
    if (loading) {
        return null;
    }
    return (_jsxs(EmptyStateContainer, { className: className, children: [img && (_jsx(ImgWrapper, { children: typeof img === 'string' ? (_jsx(Img, { src: img, alt: "tableIcon icon", className: "emptyStateImg" })) : (img) })), title && (_jsx(Typography, { type: titleType, fontFamily: titleFont, color: colors.text.secondary, children: title })), description && (_jsx(DescriptionWrapper, { children: _jsx(Typography, { type: "bodyButton", fontFamily: "primaryMedium", color: colors.text.secondary, children: description }) })), button && button] }));
};
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map